<template lang="pug">
  .page.page-desktop
    Desktop
</template>

<script>
import { mapActions } from 'vuex';
import Desktop from '../containers/Desktop.vue';

export default {
  name: 'DesktopPage',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['closePopup']),
  },
  mounted() {
    const { closePopup } = this;
    closePopup();
  },
  components: {
    Desktop,
  }
}
</script>

<style lang="scss">

</style>
